import React, { useState, useEffect } from "react";
import Stack from "@mui/material/Stack";
import { Paper, ButtonGroup, Button } from "@mui/material";
import { SFTypography, getStyled } from "@sf-core";
import { baseContainer } from "@base-provider";
import { useTranslation } from "react-i18next";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useAuth0 } from "@auth0/auth0-react";

import _ from "lodash";
import { ReactComponent as EyLogo } from "./images/logo.svg";

const { styled } = getStyled();

const Item = styled(Paper)(({ theme }) => ({
  textAlign: "center",
}));

const TenantForm = ({ onSelect }) => {
  const { t } = useTranslation();

  const { user } = useAuth0();
  let displayUserName = user.name ? user.name.split(" ")[0] : user.username;

  const [tenants, setTenants] = useState({ loading: true });

  useEffect(() => {
    baseContainer.authenticationService.getTenants().then((r) => {
      setTenants(_.orderBy(r, ["name"]));
    });
  }, []);

  if (tenants.loading) return null;

  return (
    <Stack spacing={2} sx={{ width: "90%" }}>
      <Item elevation={0}>
        <EyLogo />
      </Item>
      <Item elevation={0}>
        <SFTypography
          variant="h1"
          sx={{
            color: "#3A3A4A",
            fontSize: 28,
          }}
        >
          {t("tenantSelectionScreen.title", { name: displayUserName })}
        </SFTypography>
      </Item>
      <Item elevation={0}>
        <SFTypography
          variant="body1"
          sx={{
            color: "#747480",
          }}
        >
          {t("tenantSelectionScreen.subtitle")}
        </SFTypography>
      </Item>
      <Item elevation={0}>
        <ButtonGroup
          orientation="vertical"
          fullWidth
          variant="text"
          size="large"
          sx={{
            "& .MuiButtonGroup-grouped:not(:last-of-type)": {
              borderColor: "#EAEAF2",
            },
          }}
        >
          {tenants.map((tenant) => (
            <Button
              key={tenant.name}
              sx={{
                fontSize: 16,
                fontWeight: 400,
                lineHeight: "22px",
                p: 2,
                color: "#1A1A24",
                justifyContent: "space-between",
                border: 0,
              }}
              endIcon={<ArrowForwardIosIcon sx={{ color: "#1777CF" }} />}
              onClick={() => onSelect(tenant)}
            >
              {tenant.name}
            </Button>
          ))}
        </ButtonGroup>
      </Item>
    </Stack>
  );
};

export default TenantForm;
